import { type ReactNode } from 'react';

import cn from 'classnames';

import styles from './Highlight.module.scss';

type Color = 'navy' | 'white' | 'blue' | 'teal' | 'green' | 'purple' | 'lime' | 'lightBlue' | 'dark';

type Font = 'mono';

type Props = {
  children: ReactNode;
  variant?: 'color' | 'underline' | 'both';
  color?: Color;
  bold?: boolean;
  font?: Font;
  uppercase?: boolean;
  className?: string;
};

export const Highlight = ({ children, variant = 'color', color = 'navy', bold, font, uppercase, className }: Props) => {
  return (
    <span
      className={cn(
        styles.gdbHighlight,
        styles[`gdbHighlight_${variant}`],
        styles[`gdbHighlight_color__${color}`],
        bold && styles.gdbHighlight_bold,
        font && styles[`gdbHighlight_font__${font}`],
        uppercase && styles.gdbHighlight_uppercase,
        className,
      )}
    >
      {children}
    </span>
  );
};
